"use client";
import l, { useId as v } from "react";
import "./index.es73.js";
import "./index.es74.js";
import "./index.es75.js";
import "./index.es76.js";
import "./index.es77.js";
import "./index.es78.js";
import d from "./index.es79.js";
import _ from "./index.es141.js";
const o = "__EMPTY_STR__", f = _.div`
  .bl-select select[disabled] {
    background-color: var(--bl-c-sand-4);
    color: var(--bl-c-neutral-1);
  }
  .bl-select .bl-input {
    display: flex;
    align-items: center;
  }
`, I = ({
  name: m,
  value: a,
  label: i,
  options: t,
  onChange: c
}) => {
  const s = v(), b = t.map(
    (e) => e.value !== "" ? e : { value: o, label: e.label }
  ), p = (e) => {
    let n = e.target.value;
    n === o && (n = ""), c(n);
  }, r = t.length < 2, u = t.find((e) => e.value === a)?.label || a;
  return /* @__PURE__ */ l.createElement(f, null, r && /* @__PURE__ */ l.createElement("div", { className: "bl-select" }, /* @__PURE__ */ l.createElement("div", { className: "bl-select__label bl-size-6 bl-p-b-1" }, i), /* @__PURE__ */ l.createElement("div", { className: "bl-input" }, u)), !r && /* @__PURE__ */ l.createElement(
    d,
    {
      isDisabled: r,
      label: i,
      name: m,
      value: a,
      onChange: p,
      inputId: s
    },
    b.map((e) => /* @__PURE__ */ l.createElement(
      "option",
      {
        key: e.value,
        value: e.value,
        "aria-label": e.ariaLabel
      },
      e.label
    ))
  ));
};
export {
  I as default
};
//# sourceMappingURL=index.es80.js.map
